/**
 * Mobile Keybook tab — mounts the SAME KeybookGate + KeybookView the desktop
 * uses (App.tsx keybook deck window), with the role resolved the same way
 * (active org email's role, else session email's, else first membership).
 * KeybookView wasn't designed for 390px — a responsive pass is Phase 3 of
 * the mobile plan; until then it's functional but rough.
 */
import { useQuery } from '@tanstack/react-query'
import { ErrorBoundary } from '@papan/core-ui/ui'
import { KeybookGate, KeybookView } from '@papan/keybook/ui'
import { DrivePickerDialog } from '@papan/workspace/ui'
import { orgsApi } from '@papan/orgs/client'
import { useAuth } from '../hooks/useAuth'
import { useTenant } from '../hooks/useTenant'

export function MobileKeybookScreen() {
  const { user } = useAuth()
  const { tenantId, isPersonal, activeOrgEmail } = useTenant()

  const tenantsQuery = useQuery({
    queryKey: ['mobile-my-tenants'],
    queryFn: () => orgsApi.listMyTenants(),
    staleTime: 60_000,
  })
  const tenant = tenantsQuery.data?.tenants.find((t) => t.id === tenantId)
  const activeRole = (() => {
    if (!tenant) return undefined
    if (activeOrgEmail) return tenant.emails.find((e) => e.email === activeOrgEmail)?.role
    const sessionEntry = user?.email ? tenant.emails.find((e) => e.email === user.email) : null
    return sessionEntry?.role ?? tenant.emails[0]?.role
  })()

  if (tenantsQuery.isLoading) {
    return <p className="px-4 py-10 text-center text-sm themed-text-muted">Loading…</p>
  }

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <ErrorBoundary>
        <KeybookGate tenantId={tenantId} isOrg={!isPersonal} userRole={activeRole}>
          <KeybookView
            userId={user?.id}
            userEmail={activeOrgEmail || user?.email}
            userRole={activeRole}
            tenantId={tenantId}
            isOrg={!isPersonal}
            FilePickerDialog={DrivePickerDialog}
          />
        </KeybookGate>
      </ErrorBoundary>
    </div>
  )
}
